import { PsObject } from "@/object/core/PsObject";
import ItemLocation from "./ItemLocation";
import ItemLocationTownship from "./ItemLocationTownship";
import ConditionOfItem from "./ConditionOfItem";
import ConditionOfAddress from "./ConditionOfAddress";

export default class Address extends PsObject<Address> {
     
    id : string = '';
    name :string = '';
    phone :string = '';
    pincode  :string = '';
    address1  :string = '';
    address2  :string = '';
    conditionOfItemId : string = '' 
    itemLocationId : string = '' ;
    itemLocationTownshipId : string = '';
    latitude : string = '' ;
    longitude : string = '' ;
    addedUserId : string = '';
    loginUserId : string = '';
    Default : string = '';
    itemLocation : ItemLocation = new ItemLocation();
    itemLocationTownship : ItemLocationTownship = new ItemLocationTownship();
    conditionOfAddress : ConditionOfAddress = new ConditionOfAddress();
    // conditionOfItem : ConditionOfItem = new ConditionOfItem();


    init(
        
        id : string,
        name : string,
        phone : string,
        pincode : string,
        address1 : string,
        address2 : string,
        conditionOfItemId : string,
        itemLocationId : string,
        itemLocationTownshipId : string,
        latitude : string,
        longitude : string,
        addedUserId : string,
        loginUserId : string,
        Default : string,
        itemLocation : ItemLocation,
        itemLocationTownship : ItemLocationTownship,
        conditionOfAddress : ConditionOfAddress,
        // conditionOfItem : ConditionOfItem
    
    ) {
        this.id = id,
        this.name = name,
        this.phone = phone,
        this.pincode  = pincode,
        this.address1  = address1,
        this.address2  = address2,
        this.conditionOfItemId = conditionOfItemId;
        this.itemLocationId = itemLocationId;
        this.itemLocationTownshipId = itemLocationTownshipId;
        this.latitude = latitude;
        this.longitude = longitude;
        this.addedUserId = addedUserId;
        this.loginUserId = loginUserId;
        this.Default = Default;
        this.itemLocation = itemLocation;
        this.itemLocationTownship = itemLocationTownship;
        this.conditionOfAddress = conditionOfAddress;
        // this.conditionOfItem = conditionOfItem;
        
        return this;

    }

    getPrimaryKey(): string {
        return this.id;
    }

    toMap(object: Address): any {
        const map = {};

        map['id'] = this.id;
        map['name'] = this.name;
        map['phone'] = this.phone;
        map['pincode'] = this.pincode;
        map['address1'] = this.address1;
        map['address2'] = this.address2; 
        map['condition_of_item_id'] = this.conditionOfItemId;
        map['item_location_id'] = this.itemLocationId;
        map['item_location_township_id'] = this.itemLocationTownshipId;
        map['lat'] = this.latitude;
        map['lag'] = this.longitude;
        map['added_user_id'] = this.addedUserId;
        map['login_user_id'] = this.loginUserId;
        map['default_address'] = this.Default;
        map['item_location'] = new ItemLocation().toMap(object.itemLocation);
        map['item_location_townships'] = new ItemLocationTownship().toMap(object.itemLocationTownship);
        map['condition_of_address'] = new ConditionOfAddress().toMap(object.conditionOfAddress);
        // map['condition_of_item'] = new ConditionOfItem().toMap(object.conditionOfItem);

      


        return map;
    }

    toMapList(objectList: Address[]): any[] {
        const mapList: any[] = [];
        for (let i = 0; i < objectList.length; i++) {
            if (objectList[i] != null) {
                mapList.push(this.toMap(objectList[i]));
            }
        }

        return mapList;
    }

    fromMap(obj: any) {
        return new Address().init(
            obj.id,
            obj.name,
            obj.phone,
            obj.pincode,
            obj.address1,
            obj.address2,
            obj.condition_of_item_id,
            obj.item_location_id,
            obj.item_location_township_id,
            obj.lat,
            obj.lag,
            obj.added_user_id,
            obj.login_user_id,
            obj.default_address,
            new ItemLocation().fromMap(obj.item_location),
            new ItemLocationTownship().fromMap(obj.item_location_townships),
            new ConditionOfAddress().fromMap(obj.condition_of_address),
            // new ConditionOfItem().fromMap(obj.condition_of_item),
        );
    }

    fromMapList(objList: any[]): Address[] {
        const addressList: Address[] = [];
        for (const obj in objList) {
            if (obj != null) {
                addressList.push(this.fromMap(obj));
            }
        }

        return addressList;
    }
}
